// removed by extract-text-webpack-plugin
module.exports = {"links":"links___3bPm3","linksInner":"linksInner___2DkpO","linksUpper":"linksUpper___3Jqf5","name":"name___3ApsX","blackLink":"blackLink___mBE7N","linksLower":"linksLower___2VMZx","copyright":"copyright___ZUmJp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/WhiteLabelFooter/Links/Links.scss
// module id = UuWU
// module chunks = 60